import { FlashMessageActions } from '@src/redux/actions/flashMessages/flashMessage.enum';
import {
  RemoveFlashMessageAction,
  SetFlashMessageAction,
  SetFlashMessagePayload,
} from '@src/redux/actions/flashMessages/flashMessage.interface';

const DEFAULT_STATE: SetFlashMessagePayload[] = [];

export function flashMessages(
  state = DEFAULT_STATE,
  action: SetFlashMessageAction | RemoveFlashMessageAction,
): SetFlashMessagePayload[] {
  switch (action.type) {
    case FlashMessageActions.SET_FLASH_MESSAGE: {
      // This exists for tests
      if (window.shouldDisableFlashMessages === true) {
        return [];
      }

      return [...state, action.flashMessage];
    }

    case FlashMessageActions.REMOVE_FLASH_MESSAGE:
      return state.filter(item => item.id !== action.id);

    default:
      return state;
  }
}
